import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { MdHourglassBottom, MdOutlineVerified } from 'react-icons/md';
import { MdBarChart, MdPlayCircle } from 'react-icons/md';
import TestsVector from 'assets/vectors/Tests.svg';
import ButtonLink from 'components/ButtonLink';
import { DISABLE_TEST_REPORT } from 'global/constants';
import { Test } from 'global/types';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

type MyTestsProps = {
    tests: Test[];
    testType: string;
};

function MyTests({ tests, testType }: MyTestsProps) {
    const navigate = useNavigate();

    const { organization } = useAppSelector(state => state.organization);

    return (
        <>
            {tests.find(test => !test.score && test.inProgress) && <>
                <h4 className='myTests__subHeader'>In progress</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && test.inProgress).map(test => (
                        <button 
                            className='myTests__test' 
                            onClick={() => 
                                navigate(
                                    testType === 'digital-sat'
                                        ? `/digital/sat/${test.testId}`
                                        : `/digital/act/${test.testId}`
                                )
                            } 
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {Math.round(
                                            100 * test.testSections.reduce((total, section) => (
                                                total + section.testModules.filter(module => module.rawScore !== null).length
                                            ), 0) / test.testSections.reduce((total, section) => (
                                                total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                            ), 0)
                                        )}% complete
                                    </p>
                                    {test.type==='Digital SAT' ?
                                        <p>resume {test.testSections.find(testSection => (
                                                !testSection.score
                                            )).testModules.find(testModule => (
                                                !testModule.rawScore
                                            )).name}
                                        </p>
                                        : 
                                        <p>resume {test.testSections.find(testSection => (
                                                !testSection.score
                                            )).testModules.find(testModule => (
                                                !testModule.rawScore
                                            )).name.replace('Module 1', '')}
                                        </p>
                                    }
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => !test.score && !test.inProgress) && <>
                <h4 className='myTests__subHeader'>Not started</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && !test.inProgress).map(test => (
                        <button 
                            className='myTests__test' 
                            onClick={() => 
                                navigate(
                                    testType === 'digital-sat'
                                        ? `/digital/sat/${test.testId}`
                                        : `/digital/act/${test.testId}`
                                )
                            } 
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {test.subjects}
                                        {/* {test.testSections.map((testSection, t) => (
                                            t > 0 ? ` & ${testSection.subject}` : testSection.subject
                                        ))} {test.testSections.length > 1 ? 'Sections' : 'Only'} */}
                                        {/* {100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete */}
                                    </p>
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => test.score) && <>
                <h4 className='myTests__subHeader'>Completed</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => test.score).map(test => (
                        <button
                            className={(test.testReview && !DISABLE_TEST_REPORT.includes(organization.alias)) ? 'myTests__test' : 'myTests__test--inactive'}
                            onClick={() => (test.testReview && !DISABLE_TEST_REPORT.includes(organization.alias)) && 
                                navigate(`/report/${testType}/${test.testId}`)
                            }
                            key={test.testId}
                        >
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {test.subjects}
                                        {/* {test.testSections.map((testSection, t) => (
                                            t > 0 ? ` & ${testSection.subject}` : testSection.subject
                                        ))} {test.testSections.length > 1 ? 'Sections' : 'Only'} */}
                                        {/* {100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete */}
                                    </p>
                                    <p>
                                        {new Date(test.testDate).toLocaleString('en-us', { year: 'numeric', month: 'numeric', day: 'numeric' })}
                                    </p>
                                </div>
                            </div>
                            <MdBarChart className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {/* <div className='myTests'>
                {tests.map(test => (
                    <div className='myTests__test'>
                        <img
                            className='myTests__vector'
                            src={TestsVector}
                        />
                        <h2 className='myTests__name'>
                            {test.name}
                            {test.score
                                ? <MdOutlineVerified className='myTests__check' />
                                : test.inProgress
                                ? <MdHourglassBottom className='myTests__inProgress' />
                                : <></>
                            }
                        </h2>
                        {test.score
                        ?   <ButtonLink
                                className='myTests__button'
                                to={`/report/digital-sat/${test.testId}`}
                            >
                                VIEW RESULTS
                            </ButtonLink>
                        :   test.inProgress
                        ?   <ButtonLink
                                className='myTests__button'
                                to={`/digital/${test.testId}`}
                            >
                                RESUME
                            </ButtonLink>
                        :   <ButtonLink
                                className='myTests__button'
                                to={`/digital/${test.testId}`}
                            >
                                START
                            </ButtonLink>
                        }
                    </div>
                ))}
            </div> */}
        </>
    );
}

export default MyTests;